import React from 'react';
import './CSS/Footer.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faLinkedin, faInstagram } from '@fortawesome/free-brands-svg-icons';

function Footer() {
  return (
    <footer className="footer">
      <div className="footer-content">
        <p>&copy; 2024 AyAVET Clínica Veterinaria. Todos los derechos reservados.</p>
        <div className="social-icons">
          <a href="https://es.linkedin.com/company/clinica-veterinaria-ayavet" target="_blank" rel="noopener noreferrer" aria-label="Linkedin">
            <FontAwesomeIcon icon={faLinkedin} className="social-icon" />
          </a>
          <a href="https://www.instagram.com/ayavet_es/" target="_blank" rel="noopener noreferrer" aria-label="Instagram">
            <FontAwesomeIcon icon={faInstagram} className="social-icon" />
          </a>
        </div>
      </div>
    </footer>
  );
}

export default Footer;